import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=c1d1bfcc&scoped=true"
import script from "./ClientPage.vue?vue&type=script&lang=js"
export * from "./ClientPage.vue?vue&type=script&lang=js"
import style0 from "./ClientPage.vue?vue&type=style&index=0&id=c1d1bfcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d1bfcc",
  null
  
)

export default component.exports